import { GroupsState } from './interface';

export const initialState: GroupsState = {
  groupLists: {
    data: [],
    status: null,
  },
  groupsTree: {
    data: [],
    status: null,
  },
  groupsStyle: null,
};